import React from "react";
import { Route, Switch } from "react-router-dom";
import Missions from "./Missions.jsx";
import ProductCatalog from "./ProductCatalog.jsx";

/**
 * @returns {*}
 * @constructor
 */
const MissionsAndShopping = () => {
  return (
    <Switch>
      <Route path="/missions/product_catalog">
        <ProductCatalog />
      </Route>
      <Route exact path="/missions">
        <Missions />
      </Route>
    </Switch>
  );
};

export default MissionsAndShopping;
